import { BrandingStyle, CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_route, CCTM_subnav, NavLink, useBCMSModal, useModel, useRoute } from "@bcm-dev/bcms-vite";

import Util from "classes/Util";
import Nav from "components/shared/containers/Nav";

import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from 'components/custom-ui/CustomAccordion';
import CustomDrawer, { CustomDrawerContent, CustomDrawerFooter, CustomDrawerHeader } from 'components/custom-ui/CustomDrawer';
import { ModalSecondaryButton } from 'components/custom-ui/CustomModal';
import React, { useEffect, useState } from 'react';
import { SVGAsset } from 'res';
import { UtilityNavBadge } from '../UtilityNavView';
import "./styles.css";


const MobileNavViewContext = React.createContext(null);

/**
 * @function MobileNavView
 * @extends React.Component
 * @exported true
 * @description The main component for the navigation on mobile.
 * @note 
 * - This component combines the links from the MainNavView and the UtilityNavView and is only shown on mobile.
 * - This is used as a modal, using the CustomDrawer component. To open it you will use ModalOpen id="MobileNavView".
 * @example
 * <ModalOpen id="MobileNavView">
 *  <button>Open Menu</button>
 * </ModalOpen>
 */
 function SubDropdown(props){
  const {demos } = useModel();

  return <CCTM xml={props.currentNode} self={MobileNavSubDropdownMenuItem} data={props.data}>            
                     <CCTM_subnav component={SubDropdown}  /> 
                      <CCTM_route component={MobileNavMenuItem}/>                  
                      <CCTM_link component={MobileNavMenuItem} /> 
                      <CCTM_item component={MobileNavMenuItem} />
                      <CCTM_items component={Parent}/>                   
                      <CCTM_demo component={MobileNavMenuItem} demos={demos}/>                       
                  </CCTM>;
}
    function Dropdown(props){
      const {demos } = useModel();
        return <CCTM xml={props.currentNode} self={MobileNavDropdownMenuItem} data={props.data}>            
                           <CCTM_subnav component={SubDropdown}  /> 
                            <CCTM_route component={MobileNavMenuItem}/>                  
                            <CCTM_link component={MobileNavMenuItem} /> 
                            <CCTM_item component={MobileNavMenuItem} />
                            <CCTM_items component={Parent}/>                   
                            <CCTM_demo component={MobileNavMenuItem} demos={demos}/>                       
                        </CCTM>;
    }
    function checkIfMabiChat(component,data){
    
    
      
      if(data.id == "sideNav_cards" ){
      
          if(data.target=="window"){
              return MabiCardsLink
          } 
          return component;
     
      
    }
      if(data.id == "sideNav_messages" || data.id == "respNav_messages"){
        
        return MobileMessagesNavItem;
    }
      return component;
  }

    export default function MobileNavView(props) {
      const id = Util.inMabi ?"sideNav" :"respNav" ;
      const {demos } = useModel();
            const xml =  Nav(id)
           
            const       menu = <CCTM nav-id={id} xml={xml} self={Parent}>
                                <CCTM_nav component={MobileCustomDrawer}/>                            
                                <CCTM_route component={MobileNavItem} postRender={checkIfMabiChat}/>                  
                                <CCTM_link component={MobileNavItem} postRender={checkIfMabiChat}/> 
                                <CCTM_item component={MobileNavItem}/>   
                                <CCTM_items component={MobileNavItem}/>                     
                                <CCTM_demo component={MobileNavItem} demos={demos}/> 
                                 <CCTM_subnav component={Dropdown}/>              
                            </CCTM>;
      
          
          return menu;
         
/**<Nav 
            nav-id={id} 
            nav={MobileCustomDrawer}
            subnav={<Subnav 
                    self={MobileNavDropdownMenuItem}
                    subnav={MobileNavSubDropdownMenuItem}  
                    item={MobileNavMenuItem} 
                    items={MobileNavMenuItem} 
                    link={MobileNavMenuItem} 
                    route={MobileNavMenuItem} 
                    demo={MobileNavMenuItem}    /> 
              } 
            item={MobileNavItem} 
            items={MobileNavItem} 
            link={MobileNavItem} 
            route={MobileNavItem} 
            demo={MobileNavItem}      
            > 
       </Nav> */

}
export function Parent(props){
  return <>
      {props.children}
      </>
}
export function MobileCustomDrawer(props) {
  const { user, demos, branding } = useModel();
  const navigate = useRoute();
  const username = `${ user.first } ${ user.last }`;
  const [visible, setVisible] = useState("");
  const userID = user.id.toUpperCase();
  const logout = () => {
    if (Util.inMabi) {
      Util.routeMabi("login")
    } else {
      navigate("/login")
    }
  }
  const options = useModel().branding.options;
  const paymentsLabel = options.payments_label_abi22.length ? options.payments_label_abi22 : "Payments";
 

  return (
    <MobileNavViewContext.Provider value={{ visible, setVisible }}>

      <CustomDrawer className="mobile-nav-view show-on-mobile">
        <CustomDrawerHeader id="MobileNavView" dataPoint="Mobile_Nav_Header">
          <div className="flex-container flex-horizontal align-center">
            <div className="set-width">
              <UtilityNavBadge initials={user.initials} />
            </div>
            <div className="flex-width">
              <span className="user-name-text">{username}</span>
            </div>
          </div>
        </CustomDrawerHeader>
        < CustomDrawerContent>
        {props.children}
        </CustomDrawerContent>
        <CustomDrawerFooter>
          <ModalSecondaryButton text="Log Out" onClick={logout} dataPoint="Nav_Logout"/>
        </CustomDrawerFooter>
      </CustomDrawer>
    </MobileNavViewContext.Provider>
  )
}

const useMobileNavViewContext = () => React.useContext(MobileNavViewContext);

/**
 * @function MobileNavItem
 * @exported false
 * @description - This is the main navigation item.
 * @param {STRING} itemIcon - Sets the main navigation item left icon.
 * @param {STRING} label - Sets the label of the main navigation item.
 * @param {React.Component} children - Allows us to inject content/components into the MobileNavItem, usually an arrow for accordions.
 * @example
 * <MobileNavView>
 *  <MobileNavItem itemIcon={<SVGAsset id="ChatIcon" />} label="Chat">
 *     <div className="set-width accordion-icon-container">
          <SVGAsset id="DownChevronIcon" />
        </div>
 *  </MobileNavItem>
 * </MobileNavView>
 */
export function MobileNavItem(props) {

  const label = props.label ?? "[menu item]";
  const dataPoint = props.datapoint ? { "data-point": props.datapoint } : {};
  const className = props["custom-class"] ?? "";
let to = props.onClick?undefined:props.to ?? props.route;
let onClick = props.onClick;
let modalID = props.to?.split("modal/"); 
    const { open } = useBCMSModal();
    
    const openMenuModal = evt => {
        const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
    
        if(modalID && modalID[1]){
           open(MenuModalID, modalID[1]); 
        }
        
      }
    
    if(modalID && modalID[1]){
        to = "";
        onClick= ()=>{
         
            openMenuModal()
        };
    }
    if(props.onClick){
        to ="";
       
        onClick= ()=>{
         
            props.onClick()};
    }
if(props.id == "sideNav_chat" || props.id == "respNav_chat"){
    
   onClick = () => {
    if (Util.inMabi) {
      Util.openMabiChat()
    }
    else {
      
      window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/chat", "_blank")
    }

  };
 
}

  const customClassForIcon = props["asset_custom-class"] ? { className: props["asset_custom-class"] } : {};

  return (
    <NavLink className={className} to={to} onClick={onClick}>
      <div className="mobile-nav-view-item flex-container flex-horizontal align-center">
      <div className="icon-container set-width flex-container all-center">
          {props.asset_name ? <SVGAsset id={props.asset_name} { ...customClassForIcon } />:<></>}
          </div>

        <div className="flex-width text-container truncate-text">
          <span {...dataPoint}>{label}</span>
        </div>

        {props.children}
      </div>
    </NavLink>
  );
}
export function MobileMessagesNavItem(props) {
  
  const label = props.label ?? "[menu item]";
  const dataPoint = props.datapoint ? { "data-point": props.datapoint } : {};
  const className = props["custom-class"] ?? "";
let to = props.onClick?undefined:props.to ;


  return (
    <NavLink className={className} to={to} onClick={props.onClick}>
      <div className="mobile-nav-view-item flex-container flex-horizontal align-center">
      <div className="icon-container set-width flex-container all-center">
          {props.asset_name? <SVGAsset id={props.asset_name} />:<></>}
          </div>

        <div className="flex-width text-container truncate-text">
          <span {...dataPoint}>{label}</span>
        </div>

        <div className="set-width alert-bubble flex-container all-center">
        <span>3</span>
      </div>
      </div>
    </NavLink>
  );
}

/**
 * @function MobileNavDropdownItem
 * @exported false
 * @description - This is the main navigation item.
 * @param {STRING} itemIcon - Sets the main navigation item left icon.
 * @param {STRING} label - Sets the label of the main navigation item.
 * @param {React.Component} children - Allows us to inject content/components into the MobileNavItem, usually an arrow for accordions.
 * @example
 * <MobileNavView>
 *  <MobileNavItem itemIcon={<SVGAsset id="ChatIcon" />} label="Chat">
 *     <div className="set-width accordion-icon-container">
          <SVGAsset id="DownChevronIcon" />
        </div>
 *  </MobileNavItem>
 * </MobileNavView>
 */
export function MobileNavDropdownItem(props) {
  const itemIcon = props.asset_name ?props.asset_name: null;
  const label = props.label ?? "[menu item]";
  const dataPoint = props.datapoint ? { "data-point": props.datapoint } : {};
  const className = props["custom-class"] ?? "";
  let to = props.onClick?undefined:props.to ?? props.route;

  return (
    <NavLink className={className} to={to} onClick={props.onClick}>
      <div className="mobile-nav-menu-item flex-container flex-horizontal align-center">
        <BrandingStyle style={{ "fill": "menu_icons_abi22" }} className="icon-container set-width flex-container all-center">
          {itemIcon}
        </BrandingStyle>  
        </div>

        <div className="flex-width text-container truncate-text">
          <span {...dataPoint}>{label}</span>
        </div>

        {props.children}
     
    </NavLink>
  );
}

/**
 * @function MobileNavDropdownMenuItem
 * @exported false
 * @description - The menu item that serves as the accordion toggle.
 * @param {STRING} itemIcon - This is passed from the MobileNavItem, allows to set the left icon of the menu item.
 * @param {STRING} label - This is passed from the MobileNavItem, allows to set the label of the menu item.
 * @param {React.Component} children - Allows us to pass content/components, will always pass MobileNavMenuItems.
 * @example
 * <MobileNavView>
 *  <MobileNavDropdownMenuItem itemIcon={<SVGAsset id="GearIcon" />} label="Settings">
 *    <MobileNavMenuItem to="/accountSummary" label="Account Summary" />
 *  </MobileNavDropdownMenuItem>
 * </MobileNavView>
 */
export function MobileNavDropdownMenuItem(props) {
  const { visible, setVisible } = useMobileNavViewContext();
  const [state, setState] = useState(visible === props.label);

  const onClick = value => setVisible(value ? props.label : "");
  useEffect(() => setState(visible === props.label), [visible]);

  return (
    <CustomAccordion activeClass="open-menu-accordion" isOpen={state}>
      <CustomAccordionToggle onClick={onClick}>
        <MobileNavItem {...props}>
          <div className="set-width accordion-icon-container">
            <SVGAsset id={state ? "UpChevronIcon" : "DownChevronIcon"} />
          </div>
        </MobileNavItem>
      </CustomAccordionToggle>

      <CustomAccordionContent>
        {props.children}
      </CustomAccordionContent>
    </CustomAccordion>
  );
}

/**
 * @function MobileNavSubDropdownMenuItem
 * @param {STRING} label - The label of the dropdown item
 * @param {STRING} parentLabel - The label of the parent dropdown
 * @param {STRING} dataPoint - The data point that should be added
 * @returns {React.Component}
 * @description A sub dropdown component
 * @example
 * <MobileNavSubDropdownMenuItem label="Label" parentLabel="parentLabel" />
 */
export function MobileNavSubDropdownMenuItem(props) {
  const { visible } = useMobileNavViewContext();
  const [state, setState] = useState(false);

  const onClick = value => setState(value);
  useEffect(() => setState(props.parentLabel !== visible ? false : state), [visible]);

  return (
    <CustomAccordion activeClass="mobile-nav-sub-dropdown-menu-item open-menu-accordion" isOpen={state}>
      <CustomAccordionToggle onClick={onClick}>
        <MobileNavItem {...props}>
          <div className="set-width accordion-icon-container">
            <SVGAsset id={state ? "UpChevronIcon" : "DownChevronIcon"} />
          </div>
        </MobileNavItem>
      </CustomAccordionToggle>

      <CustomAccordionContent>
        {props.children}
      </CustomAccordionContent>
    </CustomAccordion>
  );
}

/**
 * @function MobileNavMenuItem
 * @exported false
 * @description - The menu item inside of an accordion.
 * @param {STRING} to - Sets the route.
 * @param {STRING} label - Sets the label of the item.
 * @example
 * <MobileNavDropdownMenuItem itemIcon={<SVGAsset id="GearIcon" />} label="Settings">
 *  <MobileNavMenuItem to="/accountSummary" label="Account Summary" />
 * </MobileNavDropdownMenuItem>
 */
export function MobileNavMenuItem(props) {
  const className = props["custom-class"] ?? "";
  let to = props.onClick?undefined:props.to;
  const label = props.label ?? "";
  const dataPoint = props.datapoint ? { "data-point": props.datapoint } : {};
  let onClick = props.onClick;
  let modalID = props.to?.split("modal/"); 
      const { open } = useBCMSModal();
    
      const openMenuModal = evt => {
          const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
      
          if(modalID && modalID[1]){
             open(MenuModalID, modalID[1]); 
          }
          
        }
      
      if(modalID && modalID[1]){
          to = "";
          onClick= ()=>{
           
              openMenuModal()
          };
      }
      if(props.onClick){
          to ="";
         
          onClick= ()=>{
           
              props.onClick()};
      }
  if(props.to=="/ch21" &&props.target =="window"){
    to ="";
    onClick = Util.openABI22StandaloneOverlayInMABI23;
  } else if(props.id == "sideNav_ede_statements") {
    onClick = () => {
      if (Util.inMabi) {
        Util.openMabiEDEStatementsInMABI23();
      } else {
        window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/edeStatements", "_blank");
      }
    };
  }

  return (
    <NavLink className={className} to={to} onClick={onClick}>
      
      <div className="flex-height mobile-nav-menu-item">
      
          {props.asset_name ?<span className="icon-container set-width "> <SVGAsset id={props.asset_name} />  </span>:<></>}
        
        <span className="mobile-nav-menu-item-label" {...dataPoint}>
          {label}
        </span>
      </div>
    </NavLink>
  );
} 
export function MabiCardsLink(props) {
  const className = props.className ?? "";
  const to = props.route??props.to;
  const label = props.label ?? "";
  const dataPoint = props.datapoint ? { "data-point": props.datapoint } : {};

  return (
    <NavLink className={className} to={null} onClick={Util.openABI22StandaloneOverlayInMABI23}>   
    <div className="mobile-nav-view-item flex-container flex-horizontal align-center">
    <div className="icon-container set-width flex-container all-center">
        {props.asset_name ? <SVGAsset id={props.asset_name} />:<></>}
        </div>

      <div className="flex-width text-container truncate-text">
        <span {...dataPoint}>{label}</span>
      </div>

      {props.children}
    </div>
  </NavLink>
  );
}
